<template>
    <a
        :href="
            route(url, {
                invitationToken: invitationToken,
            })
        "
    >
        <AtomicButton size="lg" color="white" class="w-full">
            <template #icon>
                <img
                    class="mr-2 h-6 w-6"
                    :src="`https://d3ljnultankpar.cloudfront.net/application/images/auth/${provider}.svg`"
                    alt="Socialite app auth image by provider"
                />
            </template>
            {{ login ? $t("vue.sign_in_with") : $t("vue.sign_up_with") }}
            {{ label }}
        </AtomicButton>
    </a>
</template>
<script lang="ts" setup>
import route from "ziggy-js";

defineProps({
    login: {
        type: Boolean,
        required: false,
        default: false,
    },
    provider: {
        type: String,
        required: true,
    },
    url: {
        type: String,
        required: true,
    },
    invitationToken: {
        type: String,
        required: false,
        default: "",
    },
    label: {
        type: String,
        required: true,
    },
});
</script>
